import {ModalComponentProps, Block, Button, Card, Col, Dialog, DialogBody, DialogFooter, Row, Text, VF, Icon} from '@mc/ui-v4';

import {Form} from 'react-final-form';
import {OnChange} from 'react-final-form-listeners';
import React from 'react';
import {ShapefileAttributeType, ShapefileMetadataVO, ShpImportApi} from '../../../api';
import {FieldArray} from 'react-final-form-arrays';
import arrayMutators from 'final-form-arrays';
import {actionApiCall} from '@mc/react-app-v4';
import {mcDelete} from '@mc/react-ui-icons';
import {getShapefileAttributeTypeItems} from '../../../enums/EnumShapefileAttributeType';
import {getStringInterpretaceItems} from '../../../enums/EnumInterpretace';

type Props = ModalComponentProps & {onSubmit: (data: ShapefileMetadataVO) => void; initialValues?: ShapefileMetadataVO};

export const SelectColumnsModal: React.FC<Props> = ({onClose, onSubmit, initialValues}) => {
    // Doplňující nastavení hodnoty závislé na typu atributu (poslední sloupec tabulky):
    //  - STRING   → výběr formátování hodnoty (interpretace), stejně jako v konfiguraci atributu (MCW-28418)
    //  - CISELNIK → nahrání CSV s hodnotami číselníku, případně přehled jejich počtu
    const renderExtraColumn = (fields, index, change) => {
        const attribute = fields.value[index];

        if (attribute.type === ShapefileAttributeType.STRING) {
            return (
                <VF.SelectBox
                    label={false}
                    name={`attributes[${index}].interpretace`}
                    items={getStringInterpretaceItems()}
                    placeholder={'Prostý text'}
                    useIdAsValue
                    allowNullValue
                    inlineValidation
                />
            );
        }

        if (attribute.type === ShapefileAttributeType.CISELNIK) {
            if (attribute.values?.length == null) {
                return (
                    <VF.File
                        label={false}
                        name={`attributes[${index}].file`}
                        // @ts-ignore
                        onUpload={async (file: File) =>
                            await actionApiCall(async () => {
                                const values = (await ShpImportApi.uploadCsv(file)).data;
                                change(`attributes[${index}].values`, values);
                            })
                        }
                    />
                );
            }
            return (
                <VF.Detail
                    label={false}
                    value={`${attribute.values.length} hodnot`}
                    addonAfter={
                        <Button
                            danger
                            icon={<Icon icon={mcDelete} />}
                            onClick={() => {
                                change(`attributes[${index}].values`, null);
                                attribute.file = null;
                            }}
                            title={'Odstranit CSV soubor'}
                        />
                    }
                />
            );
        }

        return null;
    };

    return (
        <Form initialValues={initialValues} onSubmit={onSubmit} mutators={{...arrayMutators}}>
            {({handleSubmit, submitting, form: {change}}) => {
                return (
                    <Dialog onClose={onClose} title={'Import vrstvy'} size={'xl'}>
                        <DialogBody>
                            <Card>
                                <Block>
                                    <VF.String label={'Název vrstvy'} name={'layerName'} />
                                    <FieldArray name={`attributes`}>
                                        {({fields}) => {
                                            return (
                                                <>
                                                    {/* Hlavička sloupců – popisky uvedeny jednou místo opakování v každém řádku */}
                                                    <Row className={'mb-1'}>
                                                        <Col xs={1}>
                                                            <Text strong>Import</Text>
                                                        </Col>
                                                        <Col xs={2}>
                                                            <Text strong>Původní název</Text>
                                                        </Col>
                                                        <Col xs={3}>
                                                            <Text strong>Název</Text>
                                                        </Col>
                                                        <Col xs={3}>
                                                            <Text strong>Typ</Text>
                                                        </Col>
                                                        <Col xs={3}>
                                                            <Text strong>Formátování / číselník</Text>
                                                        </Col>
                                                    </Row>
                                                    {fields.map((name, index) => (
                                                        <Row key={name + index} className={'align-items-center'}>
                                                            <Col xs={1}>
                                                                <VF.Checkbox name={`attributes[${index}].forImport`} />
                                                            </Col>
                                                            <Col xs={2}>
                                                                <VF.String readOnly label={false} name={`attributes[${index}].originalName`} />
                                                            </Col>
                                                            <Col xs={3}>
                                                                <VF.String label={false} name={`attributes[${index}].customName`} />
                                                            </Col>
                                                            <Col xs={3}>
                                                                <VF.SelectBox
                                                                    useIdAsValue
                                                                    label={false}
                                                                    name={`attributes[${index}].type`}
                                                                    items={getShapefileAttributeTypeItems()}
                                                                    inlineValidation
                                                                />
                                                                <OnChange name={`attributes[${index}].type`}>
                                                                    {() => change(`attributes[${index}].interpretace`, undefined)}
                                                                </OnChange>
                                                            </Col>
                                                            <Col xs={3}>{renderExtraColumn(fields, index, change)}</Col>
                                                        </Row>
                                                    ))}
                                                </>
                                            );
                                        }}
                                    </FieldArray>
                                </Block>
                            </Card>
                        </DialogBody>
                        <DialogFooter>
                            <Button disabled={submitting} style={'link'} onClick={onClose}>
                                Zrušit
                            </Button>
                            <Button style={'primary'} disabled={submitting} onClick={handleSubmit}>
                                Pokračovat
                            </Button>
                        </DialogFooter>
                    </Dialog>
                );
            }}
        </Form>
    );
};
